import { render } from "./SubsidiariesMore.vue?vue&type=template&id=2e5ec76a&scoped=true"
import script from "./SubsidiariesMore.vue?vue&type=script&lang=js"
export * from "./SubsidiariesMore.vue?vue&type=script&lang=js"

import "./SubsidiariesMore.vue?vue&type=style&index=0&id=2e5ec76a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5ec76a"]])

export default __exports__